import { makeStyles } from "@material-ui/core/styles";
import { isiOS, isWeb } from "../../../utils/utility";
import { fontClasses } from "../../../fontStyles";


const useMobileStyles = makeStyles((theme) => ({
  settingsCardWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "start",
    boxShadow: isWeb() ? "1px 2px 10px 0 #3f434714" : "none",
    borderRadius: isWeb() ? "10px" : "0px",
  },
  settingsCard: {
    width: "100%",
    borderBottom: "0.5px solid rgba(123,135,147,.30196078431372547)",
    minHeight: "78px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: isWeb() ? "25px 32px" : "0 20px",
    cursor:'pointer',
    "&:last-child": {
      borderBottom: "0px",
    },
  },
  subHeading: {
    fontFamily: "t-star",
    fontSize: isWeb()? "16px": "12px",
    fontStyle: "normal",
    fontWeight: "400",
    color: "#A9A9AA",
    textTransform: "uppercase",
    padding: isWeb() ? "20px 0px 20px" : "20px 20px 12px",
    backgroundColor: isWeb() ? '#fafafb' : `${theme.palette.primary.background}`,
  },

  IQAirContainer: {
    height: isWeb() ? 'unset' :isiOS() ? 'calc(100vh - 64px - env(safe-area-inset-top))' : 'calc(100vh - 64px)',
    backgroundColor: `${theme.palette.primary.background}`,
    boxShadow: isWeb()? `0 2px 10px 0 rgba(63, 67, 71, 0.08)` : `none`,
  },
  SettingHeading: {
    color: `${theme.palette.primary.subHeader} !important`,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontSize: isWeb() ? "20px" : "16px",
    fontWeight: isWeb() ? "500" : "400",
  },
  SettingBaseLine: {
    fontSize: isWeb() ? "15px !important" : "12px !important",
    color: `${theme.palette.tertiary.subtextV2} !important`,
    wordBreak: "break-word",
  },
  ChargerSettingHeading: {
    width: "100%",
    position: "relative",
  },
  ChargingSettingForwardIcon: {
    marginTop: isWeb() ? "-35px" : "-24px ",
    color: `${theme.palette.primary.arrowIcon} !important`,
    position: "absolute",
    marginLeft: " calc(100% - 13px)",
    "& svg path": {
      fill: `${theme.palette.primary.arrowIcon}`,
    },
  },
  ENLChargingSettingForwardIcon: {
    marginTop: isWeb() ? "-35px" : "-24px ",
    color: `${theme.palette.primary.arrowIcon} !important`,
    position: "absolute",
    marginLeft: " calc(100% - 60px)",
    "& svg path": {
      fill: `${theme.palette.primary.arrowIcon}`,
    },
  },
  ChargerSettingContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: `${theme.palette.tertiary.container} !important`,
    height: "auto",
    margin: "0px",
    marginTop: isWeb() ? '0px' : isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
    paddingTop: "0px",
    "&:last-child": {
      marginTop: "0px",
    },
  },
  //HVAC Details styles.
  modelcontainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: isWeb() ? 'calc(100vh - 364px)' : isiOS() ? 'calc(91vh - 64px - env(safe-area-inset-top))' : 'calc(91vh - 64px)',
    backgroundColor: isWeb() ? '#FFF !important' :`${theme.palette.tertiary.evDetailsBackgroundColor} !important`,
    position: isWeb() ? 'unset':'absolute',
    top: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
    overflowY: 'auto',
    boxShadow: isWeb()? `0 2px 10px 0 rgba(63, 67, 71, 0.08)` : `none`,
  },
  modelBody: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: isWeb() ? '#FFF':`${theme.palette.primary.background} !important`,
    flexGrow: '1'
  },
  DetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '22px 16px',
    '& .MuiFormLabel-root': {
      color: `${theme.palette.tertiary.inputLabel} !important`
    },
    '& .MuiFormLabel-root .Mui-disabled': {
      color: `${theme.palette.tertiary.inputLabel} !important`
    }
  },
  TextFieldSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '24px',
    color: `${theme.palette.tertiary.NoEvDataMessage} !important`,
 
    "& .MuiInput-underline.Mui-disabled:before": {
      content: '""', // required even when empty
      borderBottom: `1px solid ${theme.palette.primary.disabledText} !important`
    },
    
    "& .MuiInputBase-input": {
      padding: '6px 0 7px',
      borderBottom: `1px solid ${theme.palette.tertiary.inputBorderBottom} !important`,
      ...fontClasses.body2,
      fontSize: isWeb() ? '16px !important' : '12px !important',
      color: theme.palette.primary.mainText2,
    },
    "& .MuiInputLabel-formControl": {
      color: `${theme.palette.tertiary.inputText} !important`
    },
    "& .Mui-disabled": {
      color: `${theme.palette.primary.disabledText} !important`
    }
  },
  fieldEmtyErrorMessage: {
    color: `${theme.palette.tertiary.errorMessageColor} !important`,
    fontSize: '12px !important',
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    padding: '18px',
    backgroundColor : isWeb() ? '#FFF':`${theme.palette.primary.background} !important`
    // marginBottom: '24px'
  },
  buttonStyle: {
    width:isWeb()? '440px' : "100%",
    textTransform: "none",
    borderRadius: "8px",
    padding: "10px",
    fontSize: "16px !important",
    textAlign: 'center',
    alignItems: 'center',
    opacity: '100% ',
    color:'#6B7073',
    background: "#BABEC3" , 
    pointerEvents:'none',
    cursor:'pointer',
    height : isWeb() ? '40px':'unset',
    "&:focus": {
      backgroundColor: "#01B5DE !important",
    },
  },
  enableButton:{
    backgroundColor: "#01B5DE !important",
    color: `${theme.palette.tertiary.timeCardBtn} !important`,
    pointerEvents:'auto'
  },
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  //HVAC Energy Mode Styles.
  childModuleContainer: {
    padding: "16px",
    height: "100%",
    flexDirection: "column",
    marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
  },
  componentContainer: {
    flex: "1",
  },
  toastPosition: {
    marginTop: "-16px",
    marginLeft: "-16px",
    marginBottom: "16px",
  },
  learnMoreBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  learnMore: {
    display: "flex",
    padding: "16px 0px 16px 16px",
    alignItems: "center",
    background: `${theme.palette.tertiary.learnMoreBgv} !important`,
    boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.10)",
    marginBottom: "15px",
  },
  learnMoreIcon: {
    marginRight: "12px",
  },
  hyperLink: {
    ...fontClasses.body1,
    fontWeight: "500",
    textAlign: "start",
    color: `${theme.palette.tertiary.buttonV2} !important`,
  },
  card: {
    backgroundColor: `${theme.palette.tertiary.sheetContainer} !important`,
    fontWeight: "400",
    color: `${theme.palette.tertiary.cardText} !important`,
    "& .MuiCardContent-root": {
      paddingBottom: "16px !important",
    },
    "&:last-child": {
      borderBottom: "none",
    },
  },
  cardContainer: {
    borderBottom: "1px solid #d8dcde",
    marginBottom: "16px",
    paddingBottom: "16px",
    "&:last-child": {
      borderBottom: "none",
      marginBottom: "0",
      paddingBottom: "0",
    },
  },
  cardBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: '15px',
  },
  dFlex: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  listCardRadio: {
    display: "flex",
    alignItems: "center",
  },
  cardHeadingWithRadio: {
    margin: "2px 0 0 6px",
  },
  cardHeading: {
    ...fontClasses.title1,
    display: "flex",
    flexDirection: "row",
    fontWeight: "500",
    alignItems: "center",
    color: `${theme.palette.tertiary.titleBox} !important`,
  },

  smallRadioButton: {
    "& svg": {
      width: "20px",
      height: "20px"
    }
  },
  modeHeaderContainer: {
    width: "100%",
    marginLeft: "2px",
  },
  description: {
    ...fontClasses.body1,
    color: `${theme.palette.primary.msgText} !important`,
    margin: '0 25px',
  },
  dividerBorderColor: {
    width: '100%',
    backgroundColor: `${theme.palette.tertiary.dividerBorderColor} !important`,
  },

  //Range Slider Styles.
  dFlexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px',
  },
  sliderContainer: {
    backgroundColor: "#F6F7FB",
    margin: '10px',
    borderRadius: '8px'
  },
  sliderWrapper: {
    width: "100%",
    padding: '10px'
  },
  sliderHeader: {
    ...fontClasses.body1,
    color: `${theme.palette.tertiary.provisiningSubHeading}`,
  },
  sliderBaseLine: {
    ...fontClasses.body2,
    color: '#01B5DE !important'
  },
  inputText: {
    '& input':{
    textTransform:'capitalize',
    },
    
    "& label": {
      ...fontClasses.body1,
      color: '#A9A9AA',
      fontSize:isWeb() ? '16px !important':'12px !important',
      "&.MuiInputLabel-shrink": {
        transform: 'translate(0, 1.5px) scale(1)'
      }
    }
  },
  iqAirTitleContainer:{
    display:'flex',
    flexDirection:'column',
    "& span:last-child": {
      fontSize: '15px',
      color: 'rgb(111, 110, 142)',
      margin: '5px 0px',
      fontWeight: '400'
  },
  }
}));

export { useMobileStyles };
